'use client';
import React from 'react';
import { Box, Link } from '@mui/material';
import DynamicScrollHeader from '@components/DynamicScrollHeader';
import { ImageObj } from '@custom-types/ImageObj.types';
import AldarLogo from '@components/AldarLogo';
import IslandSidebarDrawer from '../IslandSidebarDrawer';

import IslandCommonButton from '../IslandCommonButton';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
type Props = {
  t?: any;
  logoImage?: ImageObj;
};
export default function HouseHeader(props: Props) {
  const { t, logoImage } = props;

  return (
    <DynamicScrollHeader
      headerClassName={cn.houseHeader}
      scrolledClassName={cn.houseHeaderScroll}
    >
      <Box className={cn.houseHeaderInner}>
        <Box className={cn.houseHeaderControls}>
          <Box className={cn.houseHeaderMenu}>
            <IslandSidebarDrawer
              navigationItems={t?.fahidIslandDrawerNavigation}
            />
          </Box>
          <Box className={cn.houseHeaderButton}>
            <IslandCommonButton
              className={cn.houseButtonElement}
              t={t}
              labelKey={t['beachHouseRegisterButton'] || 'Register Now'}
            />
          </Box>
        </Box>
        <Box className={cn.houseHeaderLogo}>
          <Link
            className={cn.houseLogoElement}
            href="https://www.aldar.com/properties/en"
            target="_blank" rel="noopener noreferrer"
          >
            <AldarLogo color="white" />
          </Link>
        </Box>
      </Box>
    </DynamicScrollHeader>
  );
}
